import {
  ErrorScreen,
  FlexBox,
  space,
  Table,
  theme,
  Typography,
} from "@waldner-laboreinrichtungen/component-system";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as PhoneIcon } from "../../public/material-icons/phone-forwarded.svg";
import { ReactComponent as WarningIcon } from "../../public/material-icons/warning.svg";
import { ReactComponent as InfoIcon } from "../../public/material-icons/wb-incandescent.svg";
import { parseError } from "../util/error-handling";

const refreshPage = () => {
  window.location.reload();
};

type ErrorScreenWithTextProps = {
  error: any; // Accept the raw error object
};

export const ErrorScreenWithText: FC<ErrorScreenWithTextProps> = ({
  error,
}) => {
  const { t } = useTranslation();
  const { details, errorCode, message } = parseError(error);

  return (
    <ErrorScreen action={refreshPage} actionText={t("page.refresh")}>
      <>
        <FlexBox alignItems="center" gap={space(1)}>
          <WarningIcon color={theme.color.warning} fontSize={30} />
          <Typography size="lg" weight="semiBold">
            {t("errorscreen.header")}
          </Typography>
        </FlexBox>
        <Table verticalAlign="baseline">
          <Table.Header columnWidth="100px" />
          <Table.Header columnWidth="290px" />
          <Table.Body>
            <Table.Row padding={`${space(4)} ${space(4)} ${space(4)} 0`}>
              <Table.Data>
                <FlexBox gap={space(1)}>
                  <InfoIcon
                    color={theme.colorPalette.grey400}
                    fontSize={theme.font.size.default.base}
                  />
                  <Typography color="black" size="xs" weight="semiBold">
                    <FlexBox>{t("errorscreen.note")}</FlexBox>
                  </Typography>
                </FlexBox>
              </Table.Data>
              <Table.Data>
                <FlexBox flexDirection="column" gap={space(1)}>
                  <Typography>{t(message)}</Typography>
                  {details && (
                    <Typography color="grey600" size="xs">
                      {details}
                    </Typography>
                  )}
                  {errorCode && (
                    <Typography color="grey600" size="xs">
                      {t("error.code")}: {errorCode}
                    </Typography>
                  )}
                </FlexBox>
              </Table.Data>
            </Table.Row>
            <Table.Row padding={`${space(4)} ${space(4)} ${space(4)} 0`}>
              <Table.Data>
                <FlexBox gap={space(1)}>
                  <PhoneIcon
                    color={theme.colorPalette.grey400}
                    fontSize={theme.font.size.default.base}
                  />
                  <Typography color="black" size="xs" weight="semiBold">
                    {t("report.telephone")}
                  </Typography>
                </FlexBox>
              </Table.Data>
              <Table.Data>
                <FlexBox>{t("errorscreen.telephone.number")}</FlexBox>
              </Table.Data>
            </Table.Row>
          </Table.Body>
        </Table>
      </>
    </ErrorScreen>
  );
};
